// Import model
import { DataviewLeadAppointmentResponse } from '../models/DataviewLeadAppointmentResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterLeadAppointmentRequest } from '../models/FilterLeadAppointmentRequest';
import { LeadAppointment } from '../models/LeadAppointment';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterLeadAppointmentRequestSerializer } from './FilterLeadAppointmentRequestSerializer';
import { LeadAppointmentSerializer } from './LeadAppointmentSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewLeadAppointmentResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewLeadAppointmentResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewLeadAppointmentResponse instance
   */
  static deserialize(json: string): DataviewLeadAppointmentResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewLeadAppointmentResponse instance
   */
  static fromObject(obj: any): DataviewLeadAppointmentResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewLeadAppointmentResponse');
    }


    const instance: DataviewLeadAppointmentResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        LeadAppointmentSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterLeadAppointmentRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewLeadAppointmentResponse instances
   */
  static deserializeArray(json: string): DataviewLeadAppointmentResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewLeadAppointmentResponse instance to a JSON string
   */
  static serialize(instance: DataviewLeadAppointmentResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewLeadAppointmentResponse instance to a plain object
   */
  static toObject(instance: DataviewLeadAppointmentResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        LeadAppointmentSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterLeadAppointmentRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewLeadAppointmentResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewLeadAppointmentResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
